import { router } from "expo-router";
import { observer } from "mobx-react";
import React from "react";
import { ScrollView, StyleSheet } from "react-native";
import { Spacer } from "~/components/Spacer";
import { BrandText } from "~/components/V2/Text/BrandText";
import { View } from "~/components/V2/View";
import { useResponsive } from "~/hooks/useResponsive";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { ButtonCircle } from "./ButtonCircle";
import type { PropsWithChildren } from "react";
import type { ViewStyle } from "react-native";

const S = StyleSheet.create({
  topContainer: {
    paddingBottom: 24 + 40,
    backgroundColor: "#F8F8F8",
  },
  bottomContainer: {
    backgroundColor: styleConstantsV2.colorWhite,
    flex: 1,
    paddingHorizontal: 24,
    paddingVertical: 40,
    marginTop: -40,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingBottom: 80,
  },
});

interface PageContainerProps {
  title?: string;
  styleBottomView?: ViewStyle;
}

export const Container = observer(function Container({
  title,
  children,
  styleBottomView,
}: PropsWithChildren<PageContainerProps>) {
  const r = useResponsive();
  const canGoBack = router.canGoBack();

  return (
    <>
      <View
        colorGrey10
        style={[
          S.topContainer,
          {
            paddingHorizontal: r(16, 16, 24),
            paddingTop: r(16, 16, 24),
          },
        ]}
      >
        {canGoBack && (
          <ButtonCircle
            iconName="left-arrow"
            size="medium"
            backgroundColor={styleConstantsV2.colorWhite}
            onPress={() => {
              router.back();
            }}
          />
        )}
        {title && (
          <>
            <Spacer extraExtraLarge />
            <BrandText weightExtraBold sizeH1 colorBlack>
              {title}
            </BrandText>
          </>
        )}
      </View>

      <ScrollView style={[S.bottomContainer, styleBottomView]}>
        {children}
      </ScrollView>
    </>
  );
});
